import { useEffect } from "react";
import ServiceAreas from "@/components/ServiceAreas";
import Reveal from "@/components/SectionReveal";
import { useSeo, localBusinessJsonLd } from "@/lib/seo";
import { SITE } from "@/data/site";

export default function ServiceAreasIndexPage() {
  useSeo({
    title: "Pool Service Areas — Tampa Bay, FL",
    description:
      "Tampa Bay Pool Pros provides pool cleaning, weekly service, green pool cleanup, filter & pump cleaning, and 24/7 emergency repair across Clearwater, Tarpon Springs, Trinity, Dunedin, Palm Harbor, Oldsmar, Westchase, Town & Country, Odessa, and Carrollwood.",
    path: "/service-areas",
    image: SITE.logo,
    jsonLd: localBusinessJsonLd(),
  });
  useEffect(() => { window.scrollTo({ top: 0 }); }, []);

  return (
    <main className="bg-white">
      <section className="pt-32 sm:pt-44 pb-10 bg-gradient-to-br from-sky-50 via-white to-amber-50/40">
        <div className="max-w-7xl mx-auto px-6 sm:px-10">
          <Reveal>
            <p className="text-xs tracking-[0.22em] uppercase font-bold text-sky-700">
              Service Areas
            </p>
            <h1 className="mt-3 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 max-w-4xl">
              Tampa Bay&apos;s local pool pros.
            </h1>
            <p className="mt-5 max-w-2xl text-slate-700 text-lg">
              We service residential pools across Pinellas, Hillsborough, and Pasco counties — choose your city
              for details on weekly pool service, green pool cleanup, and 24/7 emergency response.
            </p>
          </Reveal>
        </div>
      </section>

      <ServiceAreas />
    </main>
  );
}
